const fr = {
  nav: {
    vista3d: "Vue 3D",
    videocam: "Video Cam",
    smartdomo: "SmartDomo",
    reportSensori: "Rapport Capteurs",
    apparati: "Appareils",
    calendario: "Calendrier",
    manutenzioni: "Maintenance",
    ticket: "Tickets",
    assistente: "Assistant",
    inventario: "Inventaire",
    veicoli: "Vehicules",
    setup: "Config",
    utenti: "Utilisateurs",
  },
  header: {
    title: "SmartDomo",
    subtitle: "Gestion Intelligente des Batiments",
    admin: "Administrateur",
    user: "Utilisateur",
    logout: "Deconnexion",
  },
  auth: {
    title: "Connexion",
    subtitle: "Entrez vos identifiants pour continuer",
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    login: "Se connecter",
    loggingIn: "Connexion en cours...",
    error: "Identifiants invalides",
    userNotFound: "Utilisateur non trouve",
    wrongPassword: "Mot de passe incorrect",
    copyright: "SmartDomo - Gestion Intelligente des Batiments",
  },
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    add: "Ajouter",
    search: "Rechercher",
    filter: "Filtrer",
    close: "Fermer",
    confirm: "Confirmer",
    loading: "Chargement...",
    noData: "Aucune donnee disponible",
    actions: "Actions",
    status: "Statut",
    name: "Nom",
    description: "Description",
    category: "Categorie",
    date: "Date",
    notes: "Notes",
    details: "Details",
    back: "Retour",
    next: "Suivant",
    previous: "Precedent",
    all: "Tous",
    active: "Actif",
    inactive: "Inactif",
    online: "En ligne",
    offline: "Hors ligne",
    yes: "Oui",
    no: "Non",
    or: "ou",
    of: "de",
    total: "Total",
    export: "Exporter",
    import: "Importer",
    download: "Telecharger",
    upload: "Telecharger",
    refresh: "Actualiser",
    error: "Erreur",
    success: "Succes",
    warning: "Attention",
    info: "Info",
  },
  dashboard: {
    title: "Tableau de Bord SmartDomo",
    devices: "Appareils",
    totalDevices: "Appareils Totaux",
    onlineDevices: "Appareils En Ligne",
    offlineDevices: "Appareils Hors Ligne",
    warnings: "Alertes",
    consumption: "Consommation",
    dailyConsumption: "Consommation Journaliere",
    monthlyConsumption: "Consommation Mensuelle",
    realTimeConsumption: "Consommation en Temps Reel",
    energyMonitor: "Moniteur d'Energie",
    temperature: "Temperature",
    humidity: "Humidite",
    power: "Puissance",
    voltage: "Tension",
    current: "Courant",
    battery: "Batterie",
    doorState: "Etat de la Porte",
    open: "OUVERTE",
    closed: "FERMEE",
    on: "ALLUME",
    off: "ETEINT",
    switchOn: "allumer",
    switchOff: "eteindre",
    clickTo: "cliquez pour",
    changingState: "Changement d'etat...",
    lastMovement: "Dernier mouvement",
    today: "Aujourd'hui",
    month: "Mois",
    maintenance: "Maintenance",
    alerts: "Alertes",
    sensors: "Capteurs",
    monitoredSensors: "Capteurs Surveilles",
    connectedIntegrations: "Integrations Connectees",
    systemStatus: "Etat du Systeme",
  },
  appliances: {
    title: "Gestion des Appareils",
    addNew: "Nouvel Appareil",
    editAppliance: "Modifier l'Appareil",
    brand: "Marque",
    model: "Modele",
    serialNumber: "Numero de Serie",
    position: "Emplacement",
    purchaseDate: "Date d'Achat",
    warrantyExpiry: "Fin de Garantie",
    purchaseCost: "Cout d'Achat",
    currentValue: "Valeur Actuelle",
    consumption: "Consommation Horaire (kW)",
    dailyUsage: "Heures d'Utilisation Journaliere",
    smartPlug: "Prise Intelligente",
    provider: "Fournisseur",
    noAppliances: "Aucun appareil enregistre",
    linkedDevice: "Appareil Lie",
    invoice: "Facture",
    documents: "Documents",
    manual: "Manuel",
    photos: "Photos",
    videos: "Videos",
    instructions: "Instructions",
    serviceCenter: "Centre de Service",
    other: "Autre",
    climate: "Climat/Chauffage",
    kitchen: "Cuisine",
    lighting: "Eclairage",
    security: "Securite",
    entertainment: "Divertissement",
    cleaning: "Nettoyage",
    garden: "Jardin",
    general: "General",
    warranty: "Garantie",
    warrantyActive: "Sous Garantie",
    warrantyExpired: "Garantie Expiree",
    deleteConfirm: "Etes-vous sur de vouloir supprimer cet appareil ?",
  },
  maintenance: {
    title: "Gestion de la Maintenance",
    addNew: "Nouvelle Maintenance",
    editMaintenance: "Modifier la Maintenance",
    type: "Type",
    scheduled: "Planifiee",
    completed: "Terminee",
    inProgress: "En Cours",
    pending: "En Attente",
    cancelled: "Annulee",
    priority: "Priorite",
    high: "Haute",
    medium: "Moyenne",
    low: "Basse",
    assignedTo: "Assigne a",
    dueDate: "Date d'Echeance",
    completedDate: "Date de Completion",
    cost: "Cout",
    noMaintenance: "Aucun enregistrement de maintenance",
    appliance: "Appareil",
    history: "Historique",
    deleteConfirm: "Etes-vous sur de vouloir supprimer cet enregistrement ?",
  },
  tickets: {
    title: "Gestion des Tickets",
    newTicket: "Nouveau Ticket",
    editTicket: "Modifier le Ticket",
    subject: "Sujet",
    message: "Message",
    openTicket: "Ouvrir un Ticket",
    closeTicket: "Fermer le Ticket",
    resolved: "Resolu",
    open: "Ouvert",
    closed: "Ferme",
    inProgress: "En Cours",
    noTickets: "Aucun ticket trouve",
    priority: "Priorite",
  },
  calendar: {
    title: "Calendrier de Maintenance",
    today: "Aujourd'hui",
    month: "Mois",
    week: "Semaine",
    day: "Jour",
    noEvents: "Aucun evenement",
    months: ["Janvier", "Fevrier", "Mars", "Avril", "Mai", "Juin", "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Decembre"],
    days: ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"],
  },
  sensors: {
    title: "Rapport des Capteurs",
    temperature: "Temperature",
    humidity: "Humidite",
    energy: "Energie",
    noData: "Aucune Donnee Historique",
    collectData: "Collecter les Donnees",
    collecting: "Collecte en cours...",
    lastHour: "Derniere Heure",
    last24h: "Dernieres 24h",
    last7d: "7 Derniers Jours",
    last30d: "30 Derniers Jours",
    chart: "Graphique",
    table: "Tableau",
    sensorType: "Type de Capteur",
    readings: "Lectures",
    average: "Moyenne",
    min: "Minimum",
    max: "Maximum",
  },
  vehicles: {
    title: "Suivi des Vehicules",
    noVehicles: "Aucun vehicule trouve",
    speed: "Vitesse",
    lastUpdate: "Derniere Mise a Jour",
    plateNumber: "Plaque d'Immatriculation",
    moving: "En Mouvement",
    stopped: "Arrete",
    engineOn: "Moteur Allume",
    engineOff: "Moteur Eteint",
  },
  matterport: {
    title: "Espaces 3D",
    pois: "POI",
    sensors: "Capteurs",
    spaces: "Espaces",
    addSpace: "Espace",
    goToPoi: "Aller au POI",
    syncCloud: "Sync Cloud",
    sdkConnected: "SDK Connecte",
    sdkDisconnected: "SDK Deconnecte",
    liveData: "Donnees Live",
    linkedDevice: "Lie",
    notSynced: "Non synchro",
    noSensorLinked: "Aucun capteur lie",
    navigating: "Navigation...",
    destination: "Destination atteinte !",
  },
  setup: {
    title: "Configuration de la Propriete",
    propertyName: "Nom de la Propriete",
    address: "Adresse",
    integrations: "Integrations",
    connected: "Connecte",
    disconnected: "Deconnecte",
    connect: "Connecter",
    disconnect: "Deconnecter",
    matterportSpaceId: "Matterport Space ID",
    matterportSdkKey: "Matterport SDK Key",
    saveChanges: "Enregistrer",
    saving: "Enregistrement...",
    tokenExpired: "Token expire",
    reconnect: "Reconnecter",
  },
  users: {
    title: "Gestion des Utilisateurs",
    addUser: "Nouvel Utilisateur",
    editUser: "Modifier l'Utilisateur",
    username: "Nom d'Utilisateur",
    email: "Email",
    role: "Role",
    admin: "Administrateur",
    user: "Utilisateur",
    password: "Mot de Passe",
    fullName: "Nom Complet",
    deleteConfirm: "Etes-vous sur de vouloir supprimer cet utilisateur ?",
  },
  videocam: {
    title: "Gestion des Cameras",
    liveView: "Vue en Direct",
    snapshot: "Capture",
    refreshing: "Actualisation...",
    noCameras: "Aucune camera configuree",
    lastCapture: "Derniere Capture",
  },
  assistant: {
    title: "Chat Assistant",
    placeholder: "Ecrivez un message...",
    send: "Envoyer",
    thinking: "Je reflechis...",
    welcome: "Assistant SmartBuilding",
    description: "Posez vos questions sur vos appareils, la maintenance ou les parametres.",
  },
  language: {
    it: "Italiano",
    en: "English",
    fr: "Francais",
    es: "Espanol",
    select: "Langue",
  },
};

export default fr;
